/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Open_Folder_ButtonInputs */



/**
* | output |
* | --- |
* | "Open Folder" |
*
* @param {Explorer_Info_Open_Folder_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_open_folder_button = /** @type {((inputs?: Explorer_Info_Open_Folder_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Open_Folder_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir le dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordner öffnen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открыть папку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abrir carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("打开文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダを開く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फोल्डर खोलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abrir pasta")
	return /** @type {LocalizedString} */ ("Open Folder")
});